<template>
	<transition name="pop-fade">
		<div class="messageBox pop-fade-container" v-show="visible">
			<div class="overlay" @click="closeMsgBox(0)"></div>
			<div class="MessageContainer">
				<div class="MessageTitle" v-if="options.title">{{ options.title }}</div>
				<img :src="options.msgImg" alt="" v-if="options.msgImg" class="MessageImg">
				<div class="MessageText" v-html="options.messageText" v-if="options.messageText"
					:class="options.msgTextClass"></div>
				<div class="MessageList" v-if="options.messageList && options.messageList.length">
					<div class="item" v-for="(meal, index) in options.messageList" :key="index">
						<div class="name">{{ meal.name }}</div>
						<div class="reason">
							<div class="reasonItem" v-for="(reason, index2) in meal.reason" :key="index2">{{ reason }}
							</div>
						</div>
					</div>
				</div>
				<div class="MessageBtnBar" :class="btnBarClass">
					<div class="btn cancel" v-show="options.showCancelBtn" @click="cancelFunction">
						{{ options.cancelBtnText }}</div>
					<div class="btn confirm" v-show="options.showConfirmBtn" @click="confirmFunction">
						{{ options.confirmBtnText }}</div>
				</div>
				<img src="@/assets/images/close_white_border.png" alt="" class="close bottom" @click="closeMsgBox(1)"
					v-show="options.showClose">
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			options: {}
		}
	},
	methods: {
		cancelFunction() {
			if (this.options.cancelFn) {
				this.options.cancelFn()
			}
			this.closeMsgBox(1);
		},
		confirmFunction() {
			if (this.options.confirmFn) {
				this.options.confirmFn()
			}
			this.closeMsgBox(1);
		},
		showMsgBox(options) {
			this.options = options;
			this.visible = true;
		},
		closeMsgBox(index) {
      if (this.options.closeFn) {
				this.options.closeFn()
			}
			if (index == 0) {
				console.log("----------"+this.options.outsideTouchable);
				if (this.options.outsideTouchable == undefined || this.options.outsideTouchable) {
					this.visible = false;
				}
			} else {
				this.visible = false;
			}

		}
	},
	computed: {
		btnBarClass() {
			return { 0: '', 1: 'single', 2: 'multi' }[Number(this.options.showCancelBtn) + Number(this.options.showConfirmBtn)];
		}
	}
}
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
@import "~@/scss/transition.scss";

.messageBox {
	@include square(100%);
	@include pos-f($top: 0, $left: 0);
	z-index: 100000;

	.overlay {
		@include mask-container;
	}

	.MessageContainer {
		width: px2rem(580);
		padding: px2rem(30);
		border-radius: px2rem(10);
		background-color: white;
		@include transform-center;

		.MessageTitle {
			font-size: px2rem(32);
			width: 100%;
			color: #545b5b;
			text-align: center;
			padding-bottom: px2rem(30);
		}

		.MessageImg {
			width: auto;
			height: px2rem(350);
			margin: 0 auto;
			display: block;
		}

		.MessageText {
			text-align: center;
			color: #545b5b;
			margin-top: px2rem(30);

			font: {
				size: px2rem(28);
				weight: 300;
				line-height: px2rem(42);
			}

			&.left {
				text-align: left;
			}
		}

		.MessageList {
			max-height: px2rem(400);
			@extend %overflow-scroll;

			.item {
				@include dis-flex(flex-start, space-between);
				font-size: px2rem(26);
				font-weight: 300;
				padding: px2rem(14) 0;

				.name {
					color: #7b7f81;
				}

				.reason {
					color: #a6a6a6;
					text-align: right;
				}

				&:not(:last-child) {
					border-bottom: px2rem(1) dashed #a6a6a6;
				}
			}
		}

		.MessageBtnBar {
			@include dis-flex(center);
			margin-top: px2rem(30);

			&.single {
				@include dis-flex(center, center);
			}

			&.multi {
				@include dis-flex(center, space-between);
			}

			.btn {
				flex: 0 0 auto;
				@include square(250, 80);
				max-width: px2rem(260);
				font-size: px2rem(30);
				line-height: px2rem(80);
				text-align: center;
				border-radius: px2rem(10);

				&.confirm {
					background-color: #73c6c8;
					color: white;
				}

				&.cancel {
					border: border(#a6a6a6);
					color: #a6a6a6;
				}
			}
		}

		.close {
			@include square(60);
			@include pos-a($left: 50%, $top: 100%);
			transform: translate(px2rem(-30), px2rem(50));
		}
	}
}
</style>
